export const temCampoAgendamento = isGroup =>
	!isGroup && process.env.REACT_APP_REMOVER_AGENDAMENTO !== "on";

export const agendamentoParaEnvio = agendamento => {
	if (!agendamento) return null;
	return isNaN(new Date(agendamento).getTime()) ? null : agendamento;
};

export const paraCampoDateTime = valor => {
	if (!valor) return "";

	const data = new Date(valor);
	if (isNaN(data.getTime())) return "";

	const ano = data.getFullYear();
	const mes = String(data.getMonth() + 1).padStart(2, "0");
	const dia = String(data.getDate()).padStart(2, "0");
	const hora = String(data.getHours()).padStart(2, "0");
	const minuto = String(data.getMinutes()).padStart(2, "0");

	return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
};
